import React,{useEffect} from 'react'; 
import { toast } from 'react-toastify';   
import { StyledEngineProvider } from '@mui/material/styles';
import SignInForm from './signInForm';
import SharedLayout from '../../layouts/sharedLayout';
import { TOKEN_EXPIRED_MESSAGE } from '../../constants/actions';


const SignIn: React.FC = () => { 
  useEffect(() => { 
    const expired = localStorage.getItem('expired');
    if (expired=="true") { 
        toast.warning(`${TOKEN_EXPIRED_MESSAGE}`); 
        localStorage.removeItem('expired')
    }
  }, []);
  return (
     <StyledEngineProvider injectFirst>
      <SharedLayout> 
      <SignInForm />
    </SharedLayout>
    </StyledEngineProvider>
  );
};

export default SignIn;
